import { IconButton, Pagination, Stack } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import SvgIcon from "../../../components/Images/SvgIcon";
import moment from "moment";
import { startLoader, stopLoader, open_dialog } from "../../../lib/global";
import { DELETE_DISCOUNT_MODEL } from "../../../lib/constant";
import { getAllDiscounts } from "../../../redux/actions/discount.action";
import PagenationDropdown from "../../../components/DropDown/pagenationDropdown";
import "../../../static/css/orderCss/allOrder.css";

const statusLabelClass = (status) => {
  if (status === "ACTIVE") return "text-success";
  if (status === "SCHEDULED") return "text-primary";
  return "text-secondary";
};

function AllDiscounts({ status, setStats }) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [discountData, setDiscountData] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [pageLimit, setPageLimit] = useState(10);
  const [totalItem, setTotalItem] = useState(0);
  const limit = useRef(10);

  useEffect(() => {
    setPageNo(1);
  }, [status]);

  useEffect(() => {
    limit.current = pageLimit;
    fetchData();
  }, [status, pageLimit, pageNo]);

  const fetchData = () => {
    startLoader();
    dispatch(getAllDiscounts(status || undefined))
      .then((res) => {
        const body = res?.data;
        let rows = body?.data || [];

        if (body?.stats && setStats) {
          const total =
            (body.stats.active || 0) +
            (body.stats.scheduled || 0) +
            (body.stats.expired || 0);
          setStats({ ...body.stats, total });
        }

        setTotalItem(rows.length);
        setDiscountData(rows);
        stopLoader();
      })
      .catch(() => {
        setDiscountData([]);
        setTotalItem(0);
        stopLoader();
      });
  };

  const handlePageChange = (event, value) => {
    setPageNo(value);
  };

  const handleDelete = (id) => {
    open_dialog(DELETE_DISCOUNT_MODEL, {
      id,
      onSubmit: () => {
        setPageNo(1);
        fetchData();
      },
    });
  };

  const formatCollections = (row) => {
    if (row.collections?.length) {
      return row.collections.map((c) => c.name).join(", ");
    }
    return "-";
  };

  const handleSorting = (item, sortType, isDate = false) => {
    if (!discountData.length) return;
    startLoader();
    try {
      const sorted = [...discountData].sort((a, b) => {
        let va = a[item];
        let vb = b[item];
        if (isDate) {
          va = new Date(va);
          vb = new Date(vb);
          return sortType === "asc" ? va - vb : vb - va;
        }
        if (typeof va === "number") {
          return sortType === "asc" ? va - vb : vb - va;
        }
        va = String(va || "").toLowerCase();
        vb = String(vb || "").toLowerCase();
        if (va < vb) return sortType === "asc" ? -1 : 1;
        if (va > vb) return sortType === "asc" ? 1 : -1;
        return 0;
      });
      setDiscountData(sorted);
    } finally {
      stopLoader();
    }
  };

  const paginatedData = discountData.slice(
    (pageNo - 1) * pageLimit,
    pageNo * pageLimit
  );

  const SortIcons = ({ field, isDate = false }) => (
    <div className="d-flex flex-column">
      <ExpandLessIcon
        style={{ width: "15px", height: "15px", margin: "0px 3px", cursor: "pointer" }}
        onClick={() => handleSorting(field, "asc", isDate)}
      />
      <ExpandMoreIcon
        style={{ width: "15px", height: "15px", margin: "-5px 3px", cursor: "pointer" }}
        onClick={() => handleSorting(field, "desc", isDate)}
      />
    </div>
  );

  return (
    <React.Fragment>
      <div>
        <div className="allTeamPurchaseMain">
          <div className="tableheadTeamPurchaseProduct teamPurchase_borderLine col-5">
            <div className="d-flex">
              <div>Discount / Collections</div>
              <SortIcons field="name" />
            </div>
          </div>
          <div className="teamPurchase_tablehead teamPurchase_borderLine">
            <div className="d-flex">
              <div>Discount %</div>
              <SortIcons field="discount_pct" />
            </div>
          </div>
          <div className="teamPurchase_tablehead teamPurchase_borderLine">
            <div className="d-flex">
              <div>Start Date</div>
              <SortIcons field="start_date" isDate />
            </div>
          </div>
          <div className="teamPurchase_tablehead teamPurchase_borderLine">
            <div className="d-flex">
              <div>End Date</div>
              <SortIcons field="end_date" isDate />
            </div>
          </div>
          <div className="teamPurchase_tablehead teamPurchase_borderLine">
            <div className="d-flex">
              <div>Status</div>
              <SortIcons field="status" />
            </div>
          </div>
          <div className="teamPurchase_tablehead teamPurchase_borderLine">
            <div className="d-flex">
              <div>Products</div>
              <SortIcons field="products_affected" />
            </div>
          </div>
          <div className="tableheadfix tableheadfix_allorder teamPurchase_borderLine">
            Action
          </div>

          {!paginatedData.length ? (
            <div className="p-3">No data found</div>
          ) : (
            paginatedData.map((item) => (
              <div className="info" key={item.discount_id}>
                <div className="teamPurchase-orderId-detail-maindiv">
                  <div className="d-flex teamPurchase-orderId-detail-section">
                    <div className="teamPurchase_orderId_Detail_Name mr-3">
                      <label className="mb-0">Discount:</label>{" "}
                      <span className="text-break text-capitalize font-weight-bold">
                        {item.name || "N/A"}
                      </span>
                    </div>
                  </div>
                  <div className="teamPurchase-orderId-detail-indexId mr-1">
                    ID: {item.discount_id}
                  </div>
                </div>

                <div className="teamPurchase_tablehead_details_head">
                  <div
                    className="tableheadTeamPurchaseProduct"
                    style={{ cursor: "pointer" }}
                    onClick={() => history.push(`/products/discounts/edit/${item.discount_id}`)}
                  >
                    <div className="mx-2">
                      <div className="teamPurchase_Page_ProductBox_ProductName text-capitalize">
                        {item.name}
                      </div>
                      <div className="teamPurchase_Page_ProductBox_Product_varient">
                        Collections: {formatCollections(item)}
                      </div>
                    </div>
                  </div>
                  <div className="teamPurchase_tablehead">
                    <div className="teamPurchase_Page_ProductBox_ProductName">
                      {item.discount_pct}%
                    </div>
                  </div>
                  <div className="teamPurchase_tablehead">
                    <div className="teamPurchase_Page_ProductBox_ProductName">
                      {item.start_date
                        ? moment(item.start_date).format("DD/MM/YY")
                        : "N/A"}
                    </div>
                  </div>
                  <div className="teamPurchase_tablehead">
                    <div className="teamPurchase_Page_ProductBox_ProductName">
                      {item.end_date
                        ? moment(item.end_date).format("DD/MM/YY")
                        : "N/A"}
                    </div>
                  </div>
                  <div className="teamPurchase_tablehead">
                    <div
                      className={`teamPurchase_Page_ProductBox_ProductName text-capitalize ${statusLabelClass(
                        item.status
                      )}`}
                    >
                      {(item.status || "N/A").toLowerCase()}
                    </div>
                  </div>
                  <div className="teamPurchase_tablehead">
                    <div className="teamPurchase_Page_ProductBox_ProductName">
                      {item.products_affected ?? 0}
                    </div>
                  </div>
                  <div className="tableheadfix tableheadfix_allorder">
                    <div className="d-flex justify-content-center">
                      <IconButton
                        className="pointer"
                        onClick={() =>
                          history.push(`/products/discounts/edit/${item.discount_id}`)
                        }
                      >
                        <SvgIcon src="/icons/edit_icon.svg" alt="edit icon" />
                      </IconButton>
                      <IconButton
                        className="pointer"
                        onClick={() => handleDelete(item.discount_id)}
                      >
                        <SvgIcon src="/icons/delete_icon.svg" alt="delete icon" />
                      </IconButton>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>

      <br />
      <div className="d-flex justify-content-between align-items-center">
        <PagenationDropdown setPageQuant={setPageLimit} />
        <div className="float-right mb-1">
          <Stack spacing={2}>
            <Pagination
              count={Math.max(1, Math.ceil(totalItem / pageLimit))}
              shape="rounded"
              size="small"
              page={pageNo}
              onChange={handlePageChange}
            />
          </Stack>
        </div>
      </div>
      <br />
    </React.Fragment>
  );
}

export default AllDiscounts;
